import React from 'react';
import { Breadcrumb, BreadcrumbProps } from 'semantic-ui-react';

const BreadcrumbExample: React.FC<BreadcrumbProps> = (props) => (
  <Breadcrumb icon="right angle" {...props} />
);

export default BreadcrumbExample;
